// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2xgNA","log":"ModalInventoryLogs_log__1SOsK","date":"ModalInventoryLogs_date__2GqOs","userName":"ModalInventoryLogs_userName__2tS7j"};